<template>
    <v-card>
        <v-row class="ma-1">
            <v-card-title>
                SMS Statistic
            </v-card-title>
            <v-spacer></v-spacer>
        </v-row>
        <v-row class="ma-1">
            <v-col
                cols="3"
            >
                <v-select
                    :items="groups"
                    label="Group *"
                    :rules="groupsRules"
                    item-text="name"
                    item-value="id"
                    v-model="selectedGroup"
                ></v-select>
            </v-col>
            <v-col cols="3">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="Pick a month"
                            prepend-icon="event"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        type="month"
                        no-title
                        scrollable
                        @change="$refs.menu.save(date)"
                    >
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="3">
                <v-btn @click="getSmsLogs" color="primary">Search</v-btn>
            </v-col>
            <v-col cols="2">
                <vue-excel-xlsx
                    :data="smsLogs"
                    :columns="headers"
                    :filename="exportFilename()"
                    :sheetname="'sheet1'"
                >
                    <v-btn class="primary ma-1">
                        Export
                    </v-btn>
                </vue-excel-xlsx>
            </v-col>
        </v-row>
        <v-data-table
            v-if="smsLogs.length > 0 "
            :headers="headers"
            :items="smsLogs"
            dense
            class="display-3 font-weight-medium"
            :items-per-page="30"
            :fixed-header="true"
            height="400"
        >
            <template
                v-slot:item.amount="{ item }"
            >
                <span>{{ formatAmount(item) }}</span>
            </template>
            <template
                v-slot:item.actions="{ item }"
            >
                <v-btn
                    small
                    class="mr2"
                    @click="content(item)"
                >
                    Details
                </v-btn>
            </template>
            <template slot="body.append">
                <tr class="display-3 font-weight-medium">
                    <th class="title">Totals</th>
                    <th class="title">{{ sumField('count') ? sumField('count') : '' }}</th>
                    <th class="title"></th>
                    <th class="title">{{ sumField('amount') ? formatSum(sumField('amount')) : '' }}</th>
                    <th class="title"></th>
                </tr>
            </template>
        </v-data-table>
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <template>
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-data-table
                        :headers="subHeaders"
                        :items="subItems"
                        dense
                        :items-per-page="30"
                        class="display-3 font-weight-medium"
                    >
                        <template
                            v-slot:item.status_msg="{ item }"
                        >
                            <span>{{ getMessageID(item) }}</span>
                        </template>
                        <template
                            v-slot:item.count="{ item }"
                        >
                            <span>{{ getCount(item) }}</span>
                        </template>
                        <template
                            v-slot:item.status="{ item }"
                        >
                            <span>{{ getStatus(item) }}</span>
                        </template>
                    </v-data-table>
                </v-card>
            </template>
        </v-dialog>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    props: ['groups', 'outlets'],
    data: () => {
        return {
            groupsRules: [
                v => !!v || 'Group is required',
            ],
            selectedGroup: null,
            date: new Date().toISOString().substr(0, 7),
            menu: false,
            modal: false,
            smsLogs: [],
            headers: [
                {
                    text: 'Date',
                    align: 'start',
                    value: 'date',
                    label: 'Date',
                    field: 'date'
                },
                {
                    text: 'Count',
                    value: 'count',
                    label: 'Count',
                    field: 'count'
                },
                {
                    text: 'Cost Per SMS(SGD)',
                    value: 'cost_per_sms',
                    label: 'Cost Per SMS(SGD)',
                    field: 'cost_per_sms'
                },
                {
                    text: 'Total Amount(SGD)',
                    value: 'amount',
                    label: 'Total Amount(SGD)',
                    field: 'amount',
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    label: '',
                    field: ''
                }
            ],
            subHeaders: [
                {
                    text: 'Message ID',
                    align: 'start',
                    value: 'status_msg',
                },
                {
                    text: 'From',
                    value: 'from',
                },
                {
                    text: 'Recipient No.',
                    value: 'to',
                },
                {
                    text: 'Count',
                    value: 'count',
                },
                {
                    text: 'Content',
                    value: 'content',
                },
                {
                    text: 'Status',
                    value: 'status',
                }
            ],
            subItems: [],
            dialog: false
        }
    },
    methods: {
        getSmsLogs() {
            axios.post('/api/getSmsLogs', {
                gid: this.selectedGroup,
                date: this.date,
            }).then(response => {
                this.smsLogs = response.data;
            }).catch(e => {
                console.log(e);
            })
        },
        content(item) {
            this.subItems = Object.keys(item.logs).map((key) => {
                return item.logs[key]
            });
            this.dialog = true;
        },
        getMessageID(item) {
            let msg_id = '';
            let details = JSON.parse(item.status_msg);

            if (details.length > 1) {
                details.forEach(function (item, idx, array) {
                    if (idx === array.length - 1) {
                        msg_id += item['message-id'];
                    } else {
                        msg_id += item['message-id'] + ',';
                    }
                });
            } else {
                msg_id = details[0]['message-id'];
            }

            return msg_id;
        },
        getCount(item) {
            return JSON.parse(item.status_msg).length;
        },
        getStatus(item) {
            switch (item.status) {
                case 0:
                    return "Sent";
                default:
                    return JSON.parse(item.status_msg)[0]['error-text'];
            }
        },
        formatAmount(item) {
            return item.amount.toFixed(2)
        },
        formatSum(item) {
            return item.toFixed(2)
        },
        sumField(key) {
            return this.smsLogs.reduce((a, b) => a + (b[key] || 0), 0)
        },
        exportFilename() {
            return 'SMS Report ' + this.date
        }
    },
    beforeMount() {
        if (this.groups.length === 1) {
            this.selectedGroup = this.groups[0]
        }
    }
}
</script>

<style>
.v-data-table-header th {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SMSStatistic.vue